import React from 'react';
import { BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import StatCard from './StatCard';

function CaseStudyLevel2({ data, scenarioLabel }) {
  if (!data) return null;

  const { plain_inside, plain_outside, cp_inside, cp_outside, crz_edge_count } = data;

  // Compute percentage changes
  const insideVcPct = ((cp_inside.vol_weighted_mean_vc - plain_inside.vol_weighted_mean_vc) / plain_inside.vol_weighted_mean_vc * 100);
  const insideVolPct = ((cp_inside.total_volume - plain_inside.total_volume) / plain_inside.total_volume * 100);
  const outsideVolPct = ((cp_outside.total_volume - plain_outside.total_volume) / plain_outside.total_volume * 100);

  // Bar chart data
  const barMetrics = [
    {
      title: 'Vol-Weighted Mean V/C',
      data: [
        { name: 'Inside', Baseline: plain_inside.vol_weighted_mean_vc, [scenarioLabel]: cp_inside.vol_weighted_mean_vc },
        { name: 'Outside', Baseline: plain_outside.vol_weighted_mean_vc, [scenarioLabel]: cp_outside.vol_weighted_mean_vc },
      ]
    },
    {
      title: 'Total Volume',
      data: [
        { name: 'Inside', Baseline: plain_inside.total_volume, [scenarioLabel]: cp_inside.total_volume },
        { name: 'Outside', Baseline: plain_outside.total_volume, [scenarioLabel]: cp_outside.total_volume },
      ]
    },
    {
      title: 'Total Delay (veh\u00B7s)',
      data: [
        { name: 'Inside', Baseline: plain_inside.total_delay_veh_s, [scenarioLabel]: cp_inside.total_delay_veh_s },
        { name: 'Outside', Baseline: plain_outside.total_delay_veh_s, [scenarioLabel]: cp_outside.total_delay_veh_s },
      ]
    },
  ];

  // Hourly V/C line chart data
  const hourlyData = Object.keys(plain_inside.hourly_vol_weighted_mean_vc).map(hour => ({
    hour: `${hour}-${Number(hour) + 1}`,
    Baseline: plain_inside.hourly_vol_weighted_mean_vc[hour],
    [scenarioLabel]: cp_inside.hourly_vol_weighted_mean_vc[hour],
  }));

  return (
    <div className="case-study-level">
      <h2>Level 2: Spatial / Zone Analysis</h2>

      <div className="stat-cards-row">
        <StatCard title="Zone Edges" value={crz_edge_count} change={null} />
        <StatCard title="Inside V/C (weighted)" value={cp_inside.vol_weighted_mean_vc} change={insideVcPct} />
        <StatCard title="Inside Volume" value={cp_inside.total_volume} change={insideVolPct} />
        <StatCard title="Outside Volume" value={cp_outside.total_volume} change={outsideVolPct} />
      </div>

      <div className="charts-grid">
        {barMetrics.map(metric => (
          <div key={metric.title} className="chart-container">
            <h3>{metric.title}</h3>
            <ResponsiveContainer width="100%" height={250}>
              <BarChart data={metric.data} margin={{ top: 5, right: 20, left: 20, bottom: 5 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#3a3a3a" />
                <XAxis dataKey="name" stroke="#aaa" fontSize={12} />
                <YAxis stroke="#aaa" fontSize={11} />
                <Tooltip
                  contentStyle={{ backgroundColor: '#2a2a2a', border: '1px solid #3a3a3a', color: '#fff' }}
                />
                <Legend />
                <Bar dataKey="Baseline" fill="#ffffff" opacity={0.7} />
                <Bar dataKey={scenarioLabel} fill="#7CC644" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        ))}
      </div>

      <div className="chart-container chart-full-width">
        <h3>Hourly Vol-Weighted Mean V/C (Inside Zone)</h3>
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={hourlyData} margin={{ top: 5, right: 20, left: 20, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#3a3a3a" />
            <XAxis dataKey="hour" stroke="#aaa" fontSize={11} />
            <YAxis stroke="#aaa" fontSize={11} />
            <Tooltip
              contentStyle={{ backgroundColor: '#2a2a2a', border: '1px solid #3a3a3a', color: '#fff' }}
            />
            <Legend />
            <Line type="monotone" dataKey="Baseline" stroke="#ffffff" strokeWidth={2} dot={false} />
            <Line type="monotone" dataKey={scenarioLabel} stroke="#7CC644" strokeWidth={2} dot={false} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

export default CaseStudyLevel2;
